import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["floor", "channel"]
  static values = { channels: Array }

  connect() {
    this.toggleChannels()
  }

  toggleChannels() {
    const floorPriority = this.channelsValue.indexOf(this.floorTarget.value)

    this.channelTargets.forEach(checkbox => {
      const reachable = this.channelsValue.indexOf(checkbox.value) < floorPriority

      checkbox.disabled = !reachable
      if (!reachable) checkbox.checked = false
    })
  }
}
